var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-add",
    transform: "translate(1744 -79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 37,
    height: 37,
    transform: "translate(-1744 79)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(-1742.875 80.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M16.977,7.875a1.011,1.011,0,0,1,1.011,1.011v8.09a1.011,1.011,0,0,1-1.011,1.011H8.886a1.011,1.011,0,1,1,0-2.023h7.079V8.886A1.011,1.011,0,0,1,16.977,7.875Z",
    transform: "translate(0 0)",
    fill: "#013871",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M16.875,17.886a1.011,1.011,0,0,1,1.011-1.011h8.09a1.011,1.011,0,0,1,0,2.023H18.9v7.079a1.011,1.011,0,0,1-2.023,0Z",
    transform: "translate(-0.91 -0.91)",
    fill: "#013871",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.da2710c3f03a3c7527d2668949110ac7.svg";
export { ForwardRef as ReactComponent };